import React, { memo } from "react";

export function DlqFooter({ visible, colors, selected }) {
  return (
    <div
      className={`box-border w-full rounded-b-lg border-2 border-t-0 border-dashed px-3 py-1 transition-colors duration-150 cursor-pointer ${
        selected ? "ring-2 ring-ktx-purple ring-offset-1" : ""
      }`}
      style={{
        backgroundColor: colors.bg,
        borderColor: colors.border,
        color: colors.text,
        borderLeftWidth: 4,
        borderLeftStyle: "solid",
        borderLeftColor: colors.border,
      }}
    >
      <div className="flex items-center justify-between gap-2 text-[11px] font-medium leading-tight">
        <span>
          <span className="font-semibold uppercase tracking-wide opacity-90">DLQ</span>
          <span className="opacity-70"> (in queue)</span>
        </span>
        <span>{visible}</span>
      </div>
    </div>
  );
}

function DlqNode({ data, selected }) {
  const { visible, colors } = data;
  return <DlqFooter visible={visible} colors={colors} selected={selected} />;
}

export default memo(DlqNode);
